import styled from 'styled-components/macro';
import images from '~/constants/images';

export const Container = styled.div`
  position: relative;
  background-color: ${({ theme }) => theme.dark};
  color: ${({ theme }) => theme.white};
`;

export const HeaderBackground = styled.div`
  background-size: 150%;
  background-position: center -150px;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  background-image: url(${images.beat});
  opacity: 0.1;
  background-repeat: no-repeat;
  background-position: center -780px;
  z-index: 0;

  @media (max-width: ${({ theme }) => `${theme.breakpoints.sm}px`}) {
    background-size: 150%;
    background-position: center -150px;
    z-index: -1;
  }
`;

export const Content = styled.div`
  position: relative;
  z-index: 1;
  color: ${({ theme }) => theme.white};
`;
